import type { TableQueryConfig } from "@/shared/lib/data-table/table-query"
import { MinisterKind, MinisterStatus } from "@/features/church/config/ministers/types/minister.types"

export const ministersTableQueryConfig: TableQueryConfig = {
  id: "church-config-ministers",
  search: {
    placeholderKey: "searchPlaceholder",
    debounceMs: 300,
    className: "w-full max-w-sm",
  },
  defaultSortBy: "displayName",
  defaultSortOrder: "asc",
  filters: [
    {
      id: "status",
      type: "select",
      key: "status",
      labelKey: "status",
      options: {
        type: "static",
        items: [
          { value: "", labelKey: "allStatuses" },
          { value: MinisterStatus.ACTIVE, labelKey: "active" },
          { value: MinisterStatus.INACTIVE, labelKey: "inactive" },
        ],
      },
    },
    {
      id: "kind",
      type: "select",
      key: "kind",
      labelKey: "kind",
      options: {
        type: "static",
        items: [
          { value: "", labelKey: "allKinds" },
          { value: MinisterKind.INTERNAL, labelKey: "internal" },
          { value: MinisterKind.EXTERNAL, labelKey: "external" },
        ],
      },
    },
    {
      id: "ministryTypeId",
      type: "select",
      key: "ministryTypeId",
      labelKey: "ministryType",
      options: {
        type: "collection",
        source: "ministryTypes",
        valueKey: "id",
        labelKey: "name",
        includeAllLabelKey: "allMinistryTypes",
      },
    },
  ],
}
